import { useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
// store
import AppStore from "@/app-store";
import Store from "@/core/reducers/SimpleServiceStore";
// actions
import ClientContentMetricsAction from "@/core/actions/services/metrics/ClientContentMetricsAction";
// types
import EContentMetricsType from "@/core/enums/EContentMetricsType";

export type TContentMetric = {
    contentId?:string;
    metricType:EContentMetricsType;
    count: number;
}

type TUseContentMetrics = {
    unqKey:string;
    contentId?:string;
}

const useContentMetrics = ( props:TUseContentMetrics ):TContentMetric[]|null => {
    const dispatch = useDispatch();

    const { unqKey, contentId } = props;

    const clientContentMetricsAction = new ClientContentMetricsAction(dispatch, unqKey);
    AppStore.reducerManager.add(unqKey, Store(unqKey, clientContentMetricsAction.serviceCode));
    const payload = useSelector((state:any) => state?.[unqKey]?.list?.payload, shallowEqual);

    useEffect(() => { return () => { AppStore.reducerManager.remove(unqKey); } }, [])
    useEffect(() => { if ( contentId ) _listContentMetric(contentId); }, [contentId]);

    const _listContentMetric = ( contentId:string ) => {
        clientContentMetricsAction.list({
            servicePayload: { queryOptions: { apply:`filter(contentStatus eq 1 and contentId eq ${contentId})/groupby((metricType),aggregate($count as count))` } }
        })
    }

    return payload;
}

export default useContentMetrics;
